import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const navidrome = defineConnector({
  identifier: "navidrome",
  name: "Navidrome",
  tagLine: "Self-hosted music server and streamer",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) =>
    queryAuth([
      { name: "u", value: app.config.username },
      { name: "p", value: app.secret.password },
      { name: "v", value: "1.16.1" },
      { name: "c", value: "3B" },
      { name: "f", value: "json" },
    ]),
  steps: [
    {
      title: "Enter your Navidrome details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://navidrome.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Navidrome server.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl, username }) =>
      `${instanceUrl}/rest/ping?u=${username}&v=1.16.1&c=3B&f=json`,
  },
});
